import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';

const URLS = {
  INDEX: `${apiUrlConfig.apiEndPoint()}/businesses/:business_id/business_users`,
  CREATE: `${apiUrlConfig.apiEndPoint()}/businesses/:business_id/business_users`,
  SHOW: `${apiUrlConfig.apiEndPoint()}/users/:userId`,
  UPDATE: `${apiUrlConfig.apiEndPoint()}/users/:userId`,
  DELETE: `${apiUrlConfig.apiEndPoint()}/business_users/:userId`,
};

function insertUserIdToUrl(url, id) {
  return url.replace(':userId', id);
}

function insertBusinessIdToUrl(url, id) {
  return url.replace(':business_id', id);
}

class BusinessUsersApi {
  /**
   * add new business user
   */
  static addNew(
    first_name,
    middle_name,
    last_name,
    email,
    role,
    password,
    password_confirmation,
    businessId
  ) {
    const CREATE_URL = insertBusinessIdToUrl(URLS.CREATE, businessId);
    const data = {
      business_user: {
        role,
        user_attributes: {
          first_name,
          middle_name,
          last_name,
          email,
          password,
          password_confirmation,
        },
      },
    };

    return AuthenticatedRequestService.post(CREATE_URL, data);
  }

  static updateUserRole(role, user_id, businessId) {
    const CREATE_URL = insertBusinessIdToUrl(URLS.CREATE, businessId);
    const data = {
      business_user: {
        role,
        user_id,
      },
    };

    return AuthenticatedRequestService.post(CREATE_URL, data);
  }

  /**
   * gets all business business users
   */
  static getAll(businessId) {
    const INDEX_URL = insertBusinessIdToUrl(URLS.INDEX, businessId);

    return AuthenticatedRequestService.get(INDEX_URL);
  }

  /**
   * get business business user details
   */
  static getDetails(userId) {
    const SHOW_URL = insertUserIdToUrl(URLS.SHOW, userId);

    return AuthenticatedRequestService.get(SHOW_URL);
  }

  /**
   * updates business user
   */
  static update(
    first_name,
    middle_name,
    last_name,
    email,
    role,
    password,
    password_confirmation,
    userId
  ) {
    const UPDATE_URL = insertUserIdToUrl(URLS.UPDATE, userId);
    const data = {
      user: {
        first_name,
        middle_name,
        last_name,
        email,
        role,
        password,
        password_confirmation,
      },
    };

    return AuthenticatedRequestService.patch(UPDATE_URL, data);
  }

  /**
   * deletes business user
   */
  static delete(userId) {
    const DELETE_URL = insertUserIdToUrl(URLS.DELETE, userId);

    return AuthenticatedRequestService.delete(DELETE_URL);
  }

  /**
   * update business user sms alert number
   */
  static updateSmsAlertNumber(userId, number) {
    const UPDATE_URL = insertUserIdToUrl(URLS.UPDATE, userId);
    const data = {
      user: {
        sms_alert_number: number,
      },
    };

    return AuthenticatedRequestService.patch(UPDATE_URL, data);
  }
}

export default BusinessUsersApi;



// WEBPACK FOOTER //
// ./src/apis/BusinessUsers.js